import React from 'react'
import { css } from '@emotion/core'
import { Button, colors, Typography } from '@dw/helix'
import ButtonWithLoading from '../../components/ButtonWithLoading'

const confirmSNGPanelStyles = css`
  background-color: #fff;
  padding: 0 30px 30px;
  border-radius: 2px;
  box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.19), 0 3px 3px 0 rgba(0, 0, 0, 0.13);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

const panelHeadingStyles = css`
  margin-top: 20px;
  line-height: 31px;
  margin-bottom: 3px;
`

const buttonsStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;

  button:first-of-type {
    margin-right: 20px;
  }
`
const listStyles = css`
  align-self: flex-start;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 23px;
  li {
    list-style: none;
    position: relative;
    line-height: 24px;
    &:after {
      content: '';
      position: absolute;
      width: 7px;
      height: 7px;
      left: -23px;
      top: 50%;
      transform: translateY(-50%);
      background-color: ${colors.brandBlue};
      border-radius: 50%;
    }
  }
`

interface ConfirmSerialNumberGenerationProps {
  data: any
  onClose: () => any
  onSubmit: (purchaseOrders: string[], resetForm: any) => any
  submitting: boolean
}

const ConfirmSerialNumberGeneration: React.FunctionComponent<ConfirmSerialNumberGenerationProps> = props => {
  const purchaseOrders = Object.entries(props.data.items)
    .filter(entry => entry[1])
    .map(entry => entry[0])
  return (
    <div css={confirmSNGPanelStyles}>
      <Typography type="h4" css={panelHeadingStyles}>
        Confirm serial number generation
      </Typography>

      <Typography type="snippet">
        Are you sure you want to generate serial numbers for the following purchase orders?
      </Typography>
      <ul css={listStyles}>
        {purchaseOrders.map(purchaseOrder => (
          <li key={purchaseOrder}>
            <Typography type="snippet">{purchaseOrder}</Typography>
          </li>
        ))}
      </ul>
      <div css={buttonsStyles}>
        <Button theme="secondary" onClick={props.onClose} type="button">
          Cancel
        </Button>

        <ButtonWithLoading
          onClick={() => {
            props.onSubmit(purchaseOrders, props.data.resetForm)
          }}
          type="button"
          disabled={props.submitting}
          loading={props.submitting}
          css={css`
            min-width: 254px;
          `}
        >
          Generate serial numbers
        </ButtonWithLoading>
      </div>
    </div>
  )
}

export default ConfirmSerialNumberGeneration
